module.exports = __webpack_public_path__ + "static/OldMansJourney2-6d73bf43f3ee0e31cd9d37917dd7786a.webp";